<a [href]="pubB?.link" target="_blank">
  <img  *ngIf="pubB?.imageName" [src]="publiciteImageUri + pubB?.imageName" width="100%" alt="" [title]="pubB?.titre" />
  <!--<img  *ngIf="!pubB?.imageName" src="assets/img/logo/pub1.png" width="100%" alt="" title="Pub B" />-->
</a>
